exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".hidden {\n    display: none;\n}\n\n.restore-pass {\n    color: rgba(0,0,255,0.5);\n    cursor: pointer;\n}\n.restore-pass:hover {\n    opacity: 0.5;\n}", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// ./src/app/views/login/login.css
// module id = 1226
// module chunks = 9